import moment from 'moment';
import React from 'react';
import {isNil} from 'ramda';


export const DatePretty = ({date, format = 'yyyy-MM-DD', locale, justDate = false}) => {
  const loc = isNil(locale) ? window.navigator.language : locale;

  if(isNil(date)) {
    return <>-</>
  }
  moment.locale(loc);
  const l = moment(date);

  if (justDate) {
    return l.format(format).toString();
  }

  return <>
    {l.format(format)}
  </>

};

